// components/Home.js
import React, { useEffect, useState } from 'react';
import { Box, Card, Divider, Grid, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { LayoutDashboard } from '../layouts/DasboardLayout';
import TypographyTitle from '../components/Titles/TypographyTitle';
import toast from 'react-hot-toast';
import { API_URL } from '../config';
import MensajeDialog from '../components/Dialogs/MensajeDialog';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import FunctionsIcon from '@mui/icons-material/Functions';
import { ChartBar } from '../components/Charts/Chart-bar';
import { convertirTimestamp } from '../utils/convertirTimestamp';
import ChartBarHorizontal from '../components/Charts/Chart-bar-horizontal';

const CardConfiguracion = ({ nombre, valor, icon, unidad }) => {
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 5,
        marginBottom: '1rem',
        width: '100%',
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '30%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'primary.main',
        }}
      >
        {icon}
      </Box>
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '70%',
          height: '100%',
          padding: '1rem',
        }}
      >
        <Typography
          variant='h6'
          sx={{
            color: 'primary.gold',
          }}
        >
          {nombre}
        </Typography>
        <Typography
          variant='h4'
          sx={{
            color: 'primary.black',
            fontWeight: 'bold',
          }}
        >
          {valor} {unidad}
        </Typography>
      </Stack>
    </Card>
  );
}

const Page = () => {
  const [municipios, setMunicipios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [analitics, setAnalitics] = useState(null);
  const [municipioSeleccionado, setMunicipioSeleccionado] = useState('Todos');
  const [especialidadesData, setEspecialidadesData] = useState([]);

  const getMunicipios = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/estadistica`);
      const data = await response.json();
      const dataFormatted = data.map((municipio) => ({
        id: municipio.id,
        nombre: municipio.nombre + ' - ' + municipio.fecha,
      }));
      //Agregar opcion de ver todos los municipios
      dataFormatted.unshift({ id: 'Todos', nombre: 'Todos' });

      setMunicipios(dataFormatted);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Error al obtener los municipios');
    }
  }

  const getAnalitics = async () => {
    try {
      setLoading(true);
      //Extraer la fecha y el municipio del municipioSeleccionado
      let munici = '';
      let fecha = '';
      if (municipioSeleccionado !== 'Todos') {
        munici = municipios.find((municipio) => municipio.nombre === municipioSeleccionado).id;
        fecha = municipioSeleccionado.split(' - ')[1];
      }
      const response = await fetch(`${API_URL}/person/statistics` + (municipioSeleccionado !== 'Todos' ? `?brigadaMunicipio=${munici}&fechaBrigada=${fecha}` : ''), {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });

      const data = await response.json();
      setAnalitics(data.Data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Error al obtener las configuraciones');
    }
  }

  const getEspecialidades = async () => {
    try {
      let munici = '';
      let fecha = '';
      munici = municipios.find((municipio) => municipio.nombre === municipioSeleccionado).id;
      fecha = municipioSeleccionado.split(' - ')[1];

      const response = await fetch(`${API_URL}/estadistica/especialidad?fecha=${fecha}&municipio=${munici}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.json();
      if (!data) {
        toast.error('Error al obtener las especialidades');
        return;
      }
      setEspecialidadesData({
        labels: data.map((especialidad) => especialidad.nombre),
        data: data.map((especialidad) => especialidad.total),
      });
      setLoading(false);
    } catch (error) {
      console.error(error);
      toast.error('Error al obtener las especialidades');
    }
  }

  useEffect(() => {
    getMunicipios();
  }, []);

  useEffect(() => {
    getAnalitics();
    if (municipioSeleccionado !== 'Todos') {
      getEspecialidades();
    }

    // eslint-disable-next-line
  }, [municipioSeleccionado]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'left',
        height: '100%',
        width: '100%',
        padding: '2rem',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <TypographyTitle
          variant='h4'
          marginBottom='1rem'
        >
          Estadísticas {municipioSeleccionado ? `de ${municipioSeleccionado}` : 'Totales'}
        </TypographyTitle>
        <Card
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: { xs: '100%', sm: '30%' },
            padding: 1.2,
          }}
        >
          <TextField
            fullWidth
            variant='outlined'
            label='Brigada'
            value={municipioSeleccionado}
            onChange={(e) => setMunicipioSeleccionado(e.target.value)}
            select
          >
            {
              municipios.map((municipio) => (
                <MenuItem key={municipio.id} value={municipio.nombre}>
                  {municipio.nombre}
                </MenuItem>
              ))
            }
          </TextField>
        </Card>
      </Box>

      {
        loading &&
        <Typography
          variant='h5'
          sx={{
            color: 'primary.black',
          }}
        >
          Cargando...
        </Typography>
      }
      <Divider sx={{ margin: '2rem 0' }} />
      <Typography
        variant='h5'
        sx={{
          color: 'primary.black',
          mb: '1rem',
          fontWeight: 'bold',
        }}
      >
        Registros
      </Typography>
      {
        !loading && analitics &&
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            xs={12}
            sm={6}
          >
            <Typography
              variant='h6'
              sx={{
                color: 'primary.main',
              }}
            >
              Fecha del primer registro: {convertirTimestamp(analitics?.primerRegistro)}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
          >
            <Typography
              variant='h6'
              sx={{
                color: 'primary.main',
              }}
            >
              Fecha del ultimo registro: {convertirTimestamp(analitics?.ultimoRegistro)}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
          >
            <CardConfiguracion
              nombre='Total de Registros'
              valor={analitics?.totalRegistros ?? 0}
              icon={<ShowChartIcon
                sx={{
                  color: 'primary.white',
                  fontSize: '3rem',
                }}
              />}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={3}
          >
            <CardConfiguracion
              nombre='Total de Mujeres'
              valor={analitics?.noMujeres ?? 0}
              icon={<WomanIcon
                sx={{
                  color: 'primary.white',
                  fontSize: '3rem',
                }}
              />}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
          >
            <CardConfiguracion
              nombre='Total de Hombres'
              valor={analitics?.noHombres ?? 0}
              icon={<ManIcon
                sx={{
                  color: 'primary.white',
                  fontSize: '3rem',
                }}
              />}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
          >
            <CardConfiguracion
              nombre='Edad Promedio'
              //redondear el valor de la edad promedio
              valor={analitics?.edadPromedio ? Math.round(analitics?.edadPromedio) : 0}
              icon={<FunctionsIcon
                sx={{
                  color: 'primary.white',
                  fontSize: '3rem',
                }}
              />}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 5,
                marginBottom: '1rem',
                width: '100%',
                height: '100%',
              }}
            >
              <ChartBar
                data={analitics?.cantidadProcedencia ?? []}
                labels={analitics?.municipioProcedencia ?? []}
              />
            </Box>
          </Grid>
        </Grid >
      }

      <Divider sx={{ margin: '2rem 0' }} />
      {municipioSeleccionado !== 'Todos' && especialidadesData?.data &&
        <>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '100%',
              width: '100%',
              padding: '2rem',
            }}
          >
            <Typography
              variant='h5'
              sx={{
                color: 'primary.black',
                mb: '1rem',
                fontWeight: 'bold',
              }}
            >
              Registros por especialidad
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 5,
              marginBottom: '1rem',
              width: '100%',
              height: '100%',
            }}
          >
            <ChartBarHorizontal
              data={especialidadesData?.data}
              labels={especialidadesData?.labels}
            />
          </Box>
        </>
      }
    </Box>
  );
};

const HomeEstadisticas = () => {
  return (
    <LayoutDashboard>
      <Page />
    </LayoutDashboard>
  );
}

export default HomeEstadisticas;
